import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Materiali from "./components/Materiali";
import ProtectedRoute from "./components/ProtectedRoute";
import ForgotPassword from "./pages/ForgotPassword";
import PreventivoDetail from "./components/PreventivoDetail";
import LoginGoogle from "./pages/LoginGoogle";
import PortalCliente from "./pages/PortalCliente";
import "./App.css";

// 🔹 IMPORT aggiuntivi
import axios from "axios";
import { toast } from "react-toastify";

// ✅ PUNTO 1 — Interceptor di RICHIESTA
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.withCredentials = true;
  return config;
});

// ✅ Interceptor di RISPOSTA (utile per refresh token)
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // token scaduto o non valido
      toast.error("Sessione scaduta, effettua nuovamente il login");
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

console.log("📌 ProtectedRoute importato:", ProtectedRoute);
console.log("📌 Tipo di ProtectedRoute:", typeof ProtectedRoute);
console.log({ Login, Dashboard, Materiali, ProtectedRoute, ForgotPassword, PreventivoDetail });

function App() {
  console.log("App rendered");
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/login-google" element={<LoginGoogle />} />
        <Route path="/portale" element={<PortalCliente />} />
        <Route path="/dashboard" element={<ProtectedRoute />}>
          <Route index element={<Dashboard />} />
          <Route path="materiali" element={<Materiali />} />
        </Route>
        {/* *** NUOVA ROTTA: Dettagli Preventivo *** */}
        <Route path="/preventivi/:id" element={<ProtectedRoute />}>
          <Route index element={<PreventivoDetail />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
